import { isStaging } from '@/utils/Location';
import { useAppSelector } from '@/hooks/useRedux';
import { getCampaignTranslations } from '@/redux/campaign';

export default function useTranslations<const Key extends string | string[]>(
  keys: Key,
  fallback?: Key
): Key extends string ? string : string[] {
  const translations = useAppSelector(getCampaignTranslations);

  const translate = (key: string, k?: number) => {
    const translation = translations[key];

    isStaging &&
      !translation &&
      console.error(`😱 "${key}" translation was not found.`);

    return (
      translation ??
      ((k === void 0 && (fallback as string)) || fallback?.[k!]) ??
      key
    );
  };

  return (
    Array.isArray(keys) ? keys.map(translate) : translate(keys)
  ) as Key extends string ? string : string[];
}
